import ProjectTrackerPage from "../ProjectTrackerPage";
import ProjectListPage from "../ProjectListPage";

import "./style.scss"

const ProjectPage = () => {
  return (
    <div className="projectOuterDiv">
      <ProjectTrackerPage />
      <ProjectListPage />
    </div>
  )
}

export default ProjectPage